import { COLOR } from '.';
import { nameToToken } from '../../utils';
export const isCFColor = (value) => {
    if (!value)
        return false;
    return Object.keys(COLOR).includes(nameToToken(value));
};
